import React from 'react';
import { hydrate } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import routes from './routes';

import App from './App';

const data = (window as any)._INITIAL_DATA_;

hydrate(
  <BrowserRouter>
    <App  routes={routes} serverLoadedData={data} />
  </BrowserRouter>,
  document.getElementById('root')
);

if (module.hot) {
  module.hot.accept();
}
